const ur = {
  AuthTitle: {
    Greetings: "خوش آمدید",
  },
  Auth: {
    EnterEmail: "ای میل درج کریں",
    EnterPassword: "پاس ورڈ درج کریں",
    AgreeWith: "میں متفق ہوں",
    ProcessingPersonalData: "ذاتی معلومات کی پروسیسنگ",
    UserAgreement: "صارف کا معاہدہ",
    EmailRequiredError: "ای میل ضروری ہے",
    EmailWrongFormatError: "ای میل کا فارمیٹ غلط ہے!",
    PasswordRequiredError: "پاس ورڈ ضروری ہے",
    ForgotPassword: "پاس ورڈ بھول گئے ہیں؟",
  },
  Login: {
    Title: "لاگ ان",
    Subtitle:
      "اپنے اکاؤنٹ میں لاگ ان کرنے کے لیے نیچے دیے گئے فیلڈز مکمل کریں۔",
    Login: "لاگ ان",
    Register: "رجسٹریشن",
    LoginError: "غلط لاگ ان یا پاس ورڈ درج کیا گیا ہے",
    BuyTeacherLessons: "استاد کے ساتھ اسباق خریدیں",
  },
  Register: {
    Title: "رجسٹریشن",
    Subtitle:
      "اپنے اکاؤنٹ کے لیے رجسٹریشن کرنے کے لیے نیچے دیے گئے فیلڈز مکمل کریں۔",
    Register: "رجسٹر کریں",
    Login: "لاگ ان",
    EnterLastName: "آخری نام درج کریں",
    EnterFirstName: "نام درج کریں",
    EnterEmail: "ای میل درج کریں",
    EnterGender: "صنف",
    EnterBirthday: "پیدائش کی تاریخ",
    EnterProfileCountryId: "شہریت",
    EnterProfileCityId: "آنے والا شہر",
    EnterProfileDegreeId: "تعلیم",
    EnterPassword: "پاس ورڈ درج کریں",
    RepeatPassword: "پاس ورڈ دوبارہ درج کریں",
    LastNameRequiredError: "آخری نام ضروری ہے",
    LastNameMinLengthError: "کم از کم 2 حروف",
    FirstNameRequiredError: "نام ضروری ہے",
    FirstNameMinLengthError: "کم از کم 2 حروف",
    PhoneRequiredError: "فون نمبر ضروری ہے",
    PhoneInvalidError: "غلط فون فارمیٹ",
    GenderRequiredError: "صنف ضروری ہے",
    BirthdayRequiredError: "پیدائش کی تاریخ ضروری ہے",
    ProfileCountryIdRequiredError: "شہریت ضروری ہے",
    ProfileCityIdRequiredError: "شہر ضروری ہے",
    ProfileDegreeIdRequiredError: "تعلیم ضروری ہے",
    PasswordMismatchError: "پاس ورڈز میل نہیں کھاتے",
    PasswordMinLengthError: "کم از کم 6 حروف",
  },
  Reset: {
    Title: "پاس ورڈ ری سیٹ",
    Subtitle:
      'رجسٹریشن کے دوران آپ کی فراہم کردہ ای میل درج کریں اور "بازیافت" بٹن پر کلک کریں۔',
    Reset: "بحال کریں۔",
    Login: "داخلہ",
    Success:
      "چند منٹوں میں، آپ کو <0>{{email}}</0> پر ایک ای میل موصول ہوگی جس میں اپنا پاس ورڈ بازیافت کرنے کے بارے میں ہدایات ہوں گی۔",
  },
  CookieNotice: {
    Message:
      "ہم سائٹ اور اس کے استعمال کے تجربے کو بہتر بنانے کے لیے کوکیز کا استعمال کرتے ہیں۔ سائٹ کا استعمال جاری رکھ کر، آپ کوکیز کے استعمال پر رضامند ہیں۔ آپ ہمیشہ اپنے براؤزر کی ترتیبات میں کوکیز کو غیر فعال کر سکتے ہیں۔",
    Agree: "قبول کریں، دوبارہ نہ دکھائیں",
  },
  MainPage: {
    Title: "مرکزی",
    TitleGreetings: "خوش آمدید",
    TitleGreetingsMiddle: "گَووری",
    TitleGreetingsEnd: "رو!",
    MyCourses: "میرے کورسز",
    CourseContinue: "جاری رکھیں",
    CourseCountStart: "دستیاب",
    CourseCount_one: "{{count}} کورس",
    CourseCount_other: "{{count}} کورسز",
    AllCourses: "تمام کورسز",
    MyLessons: "میرے اسباق",
    AllLessons: "تمام اسباق",
    EmptyCourses: "کوئی کورسز نہیں",
    EmptyLessons: "کوئی اسباق نہیں",
    BuyTeacherLessons: "استاد کے ساتھ اسباق خریدیں",
    BuyTeacherLessonsLink: "یہاں",
    ForeignCardTooltip: "روسی فیڈریشن سے باہر جاری کردہ کارڈز کے لیے",
    NoActiveLicense: "آپ کے پاس فعال لائسنس نہیں ہے۔",
    GoIntoLesson: "سبق میں جائیں",
    FinishedLessons: "مکمل ہو چکے ہیں",
    CanceledLessons: "منسوخ ہو چکے ہیں",
  },
  CoursesPage: {
    Title: "میرے کورسز",
    TitleGreetings: "خوش آمدید",
    MyCourses: "میرے کورسز",
    CourseContinue: "جاری رکھیں",
    EmptyCourses: "کوئی کورسز نہیں",
    SearchPlaceholder: "نام سے تلاش کریں",
    LevelPlaceholder: "سطح",
    AllLevels: "تمام درجات",
  },
  Menu: {
    Main: "مرکزی صفحہ",
    Words: "الفاظ",
    Courses: "میرے کورسز",
    Lessons: "استاد کے ساتھ اسباق",
    TeacherCorner: "اساتذہ کا گوشہ",
    AdditionalCourses: "اضافی کورسز",
    UsefulLinks: "مفید لنکس",
    Notifications: "اطلاعات",
    Video: "ویڈیو",
    TeacherGroups: "گروپس",
    TeacherAttendance: "حاضری",
    TeacherClasses: "کلاسز",
    TeacherReports: "رپورٹس",
    CreativeTasks: "تخلیقی کام",
    Attendance: "حاضری",
  },
  Footer: {
    Copyright: "جملہ حقوق محفوظ ہیں",
    About: "کمپنی کے بارے میں",
    PrivacyPolicy: "ڈیٹا کے استعمال کی پالیسی",
    PrivacyProtect: "ذاتی ڈیٹا کی پروسیسنگ اور تحفظ کے ضوابط",
  },
  Module: {
    exercise_one: "مشتمر",
    exercise_few: "مشتمرین",
    Completed: "مکمل",
    Result: "نتیجہ",
    InWork: "کام میں",
    Done: "مکمل ہوا",
  },
  SteppedProgress: {
    Completed: "مکمل",
  },
  CourseDetails: {
    Title: "کورس کی معلومات",
    Progress: "پیش رفت",
    Completed: "مکمل",
    Result: "نتیجہ",
    Hours: "گھنٹے",
    Lessons: "اسباق",
    Units: "یونٹس",
    Unit: "یونٹ",
    Exercises_zero: "{{count}} مشتمرین",
    Exercises_one: "{{count}} مشتمر",
    Exercises_other: "{{count}} مشتمرین",
    Exercises_many: "{{count}} مشتمرین",
  },
  CourseUnitDetails: {
    Vocabulary: "الفاظ",
    Video: "ویڈیو",
    Grammar: "گرامر",
    Reading: "پڑھائی",
    Writting: "تحریر",
    Speaking: "تقریر",
    Test: "ٹیسٹ",
    Unknown: "نامعلوم",
    EmptyExercises: "کوئی مشتمر نہیں",
  },
  EntranceTest: {
    ModalTitle: "اپنی علمی سطح کا تعین کریں",
    ModalBody:
      "روسی زبان کی مہارت کی سطح کا تعین کرنے کے لیے ٹیسٹ دیں۔ اوسطاً یہ ٹیسٹ 40 منٹ کا ہوتا ہے۔",
    Cancel: "منسوخ کریں",
    Take: "ٹیسٹ دیں",
  },
  TeacherPage: {
    Title: "مرکزی استاد",
    MyLessons: "میرے اسباق",
    MyModules: "میرے ماڈیولز",
  },
  DistributorPage: {
    Title: "مرکزی ڈسٹری بیوٹر",
  },
  CoordinatorPage: {
    Title: "مرکزی کوآرڈینیٹر",
  },
  Button: { Send: "بھیجیں", Download: "ڈاؤن لوڈ کریں" },
  Distributor: {
    Report: "رپورٹس",
    DateFrom: "تاریخ سے",
    DateTo: "تاریخ تک",
    Status: "حیثیت",
    StatusReady: "تیار",
    StatusPlanned: "منتظر",
    Actions: "اعمال",
    FromRequiredError: "آغاز کی تاریخ درج کریں",
    ToRequiredError: "اختتامی تاریخ درج کریں",
  },
  LessonsTable: {
    GroupName: "گروپس",
    Status: "حیثیت",
    StartDateTime: "تاریخ اور وقت",
    Duration: "گھنٹے",
    Credentials: "ویبینار: لاگ ان/پاس ورڈ",
    CredentialsCopied: "کاپی ہو گیا!",
    SortAlpabetically: "الفبائی ترتیب A-Z",
  },
  LessonStatuses: {
    completed: "مکمل",
    planned: "منصوبہ",
    earlyCanceledByCustomer: "شرکاء کے ذریعہ منسوخ",
    earlyCanceledBySchool: "استاد کے ذریعہ منسوخ",
    lateCanceledByCustomer: "شرکاء کے ذریعہ منسوخ",
    lateCanceledBySchool: "استاد کے ذریعہ منسوخ",
  },
  LessonAttendance: {
    Status: "حیثیت منتخب کریں",
    Date: "تاریخ منتخب کریں",
    Time: "وقت منتخب کریں",
    Duration: "دورانیہ",
    AH: "گھنٹے",
    Students: "طلباء",
    CheckAll: "سب کو منتخب کریں",
    Comment: "تبصرے",
    Submit: "جمع کریں",

    restrictiveBackDateError: "تاریخ اجازت سے کم نہیں ہو سکتی",
    restrictiveForwardDateError: "تاریخ اجازت سے زیادہ نہیں ہو سکتی",
    commentSizeError: "تبصرہ {{count}} الفاظ سے کم ہونا چاہیے",
    requiredFieldError: "یہ فیلڈ ضروری ہے",
    requiredDateError: "تاریخ اور وقت بھریں",
    ExcessHoursWarning: "گھنٹوں کی تعداد حد سے زیادہ ہے",
    MarkStudents:
      "کلاس میں شریک طلباء کو نشان زد کریں اور تبدیلیاں محفوظ کریں۔",
    apiError:
      "آپ کا ڈیٹا محفوظ نہیں ہوا۔ براہ کرم تکنیکی مدد سے رابطہ کریں online@dschool.ru",
    early_cancel_by_customer_not_acceptable:
      "صارف کے ذریعہ جلد منسوخی دستیاب نہیں، 2 کلاسز پہلے ہی منسوخ ہو چکی ہیں، کوآرڈینیٹر سے رابطہ کریں",
    early_cancel_by_school_not_acceptable:
      "اسکول کے ذریعہ جلد منسوخی دستیاب نہیں، 2 کلاسز پہلے ہی منسوخ ہو چکی ہیں، کوآرڈینیٹر سے رابطہ کریں",
  },
  TeacherReportsPage: {
    Title: "رپورٹس",
    HeaderTitle: "رپورٹس",
    CreateReport: "رپورٹ بنائیں",
  },
  TeacherReportTable: {
    Title: "رپورٹ کا عنوان",
    CreationDate: "تخلیق کی تاریخ",
    Period: "مدت",
    Status: "حیثیت",
    StatusDone: "مکمل",
    StatusPending: "منتظر",
    Actions: "اعمال",
    Statistics: "پلیٹ فارم کے اعداد و شمار",
    CourseProgress: "کورس کی پیش رفت",
    ActiveTime: "پلیٹ فارم کی رپورٹ پر وقت",
    EntranceTest: "ابتدائی ٹیسٹ",
    LecenseReport: "استعمال شدہ لائسنس رپورٹ",
    HeaderTitle: "رپورٹس",
    CreateReport: "رپورٹ بنائیں",
    DeleteReport: "کیا آپ یقیناً حذف کرنا چاہتے ہیں؟",
    DeleteTooltip: "حذف کریں",
    MailTooltip: "ای میل پر بھیجیں",
    DownloadTooltip: "ڈاؤن لوڈ کریں",
    DeleteGroupTooltip: "منتخب شدہ کو حذف کریں",
    MailGroupTooltip: "منتخب شدہ کو ای میل پر بھیجیں",
    DownloadGroupTooltip: "منتخب شدہ کو ڈاؤن لوڈ کریں",
  },
  CreateReportForm: {
    Statistics: "پلیٹ فارم کے اعداد و شمار",
    CourseProgress: "کورس کی پیش رفت",
    ActiveTime: "پلیٹ فارم کی رپورٹ پر وقت",
    Report: "میری رپورٹ",
    Title: "رپورٹ بنائیں",
    Type: "رپورٹ کی قسم",
    TypeLabel: "قسم",
    NameLabel: "عنوان",
    DateLabel: "تاریخ",
    DateFromLabel: "سے",
    DateToLabel: "تک",
    Name: "رپورٹ کا نام",
    Period: "مدت",
    PeriodFrom: "سے",
    PeriodTo: "تک",
    Date: "تاریخ",
    FilterListGroup: "گروپ",
    FilterListStudent: "طالب علم",
    FilterListCompany: "کسٹمر کمپنی",
    FilterListTest: "داخلہ ٹیسٹ کا نام",
    FilterListSelectedStudents: "گروپ کا فلٹر، {{count}} منتخب طالب علم",
    FilterListSelectedGroups: "گروپ کا فلٹر، {{count}} منتخب گروپس",
    FilterListCompanies: "گروپ کا فلٹر، {{count}} منتخب کمپنیاں",
    FilterListSelectedTests: "گروپ کا فلٹر، {{count}} منتخب داخلہ ٹیسٹس",
    FilterListSelectedPlaceholderStudents: "طالب علم منتخب کریں",
    FilterListSelectedPlaceholderGroups: "منتخب گروپس",
    FilterListSelectedPlaceholderCompanies: "منتخب کسٹمر کمپنیاں",
    FilterListSelectedPlaceholderTests: "داخلہ ٹیسٹس منتخب کریں",
    GroupsChosen: "منتخب شدہ گروپس",
    ChooseAll: "سب کو منتخب کریں",
    RemoveAll: "سب کو ہٹائیں",
    GroupName: "گروپ",
    GroupDefault: "گروپ ڈیفالٹ",
    Cancel: "منسوخ کریں",
    Create: "بنائیں",
    TitleRequiredError: "عنوان ضروری ہے",
    FromRequiredError: "مدت کی آغاز کی تاریخ ضروری ہے",
    ToRequiredError: "مدت کا اختتام ضروری ہے",
    GroupsRequiredError: "ایک یا زیادہ گروپس منتخب کریں!",
    OrderCreateError: "نئی رپورٹ بنانے میں ناکام",
    FieldRequiredError: "فیلڈ ضروری ہے",
    NoItems: "کوئی گروپس نہیں",
  },
  Gender: {
    Male: "مرد",
    Female: "خاتون",
  },
  Role: {
    student: "طالب علم",
    teacher: "استاد",
    distributor: "ڈسٹری بیوٹر",
    coordinator: "کوآرڈینیٹر",
  },
  EmailNotConfirmed: {
    Title:
      "پلیٹ فارم تک رسائی حاصل کرنے کے لیے آپ کے ای میل پتے {{email}} پر ایک ای میل بھیجا گیا ہے۔ براہ کرم اپنا ایڈریس تصدیق کریں۔ اگر آپ کو کوئی سوالات ہیں، تو online@dschool.ru پر لکھیں",
    Back: "<< واپس",
  },
  MyWordsPage: {
    Title: "میرے الفاظ",
    EmptyWordList:
      "سیکھنے کے لیے کوئی الفاظ نہیں ہیں۔ فلٹرز میں کوئی اور یونٹ منتخب کریں",
  },
  WordsFilter: {
    Title: "فلٹرز",
    Clear: "صاف کریں",
    EmptyCourses: "خالی کورسز",
    ChooseCourse: "کورس منتخب کریں",
    ChooseUnit: "یونٹ منتخب کریں",
    EmptyUnits: "خالی یونٹس",
  },
  SetupPassword: {
    Title: "پاس ورڈ سیٹ اپ",
    Subtitle:
      "آپ کو نیا پاس ورڈ ترتیب دینا ہوگا، نیچے دیے گئے فیلڈز میں نیا پاس ورڈ اور تصدیق درج کریں",
  },
  SetupPasswordRedirect: {
    Title: "عمل ضروری ہے",
    Description: "اس سروس کو استعمال کرنے کے لیے آپ کو پاس ورڈ سیٹ کرنا ہوگا۔",
    Redirect: "پاس ورڈ سیٹ کریں",
  },
  ChangePassword: {
    Password: "پاس ورڈ",
    PasswordRepeat: "پاس ورڈ دوبارہ درج کریں",
    Confirm: "تصدیق کریں",
    PasswordShortError: "پاس ورڈ کی لمبائی 6 حروف سے زیادہ ہونی چاہیے",
    PasswordMismatch: "پاس ورڈز کا میل ہونا ضروری ہے",
    Success: "پاس ورڈ کامیابی سے اپ ڈیٹ ہو گیا",
    Login: "اپنے پہلا پہلا صفحہ پر جائیں",
  },
  ProfilePage: {
    Title: "میری پروفائل",
  },
  Profile: {
    PersonalData: "ذاتی معلومات",
    FirstName: "نام",
    LastName: "آخری نام",
    BirthDate: "پیدائش کی تاریخ",
    Citizenship: "شہریت",
    Degree: "تعلیم",
    City: "آنے والا شہر",
    NewPassword: "نیا پاس ورڈ",
    ConfirmNewPassword: "نیا پاس ورڈ کی تصدیق کریں",
    Password: "پاس ورڈ",
    Save: "محفوظ کریں",
    DataUpdateSuccess: "معلومات کامیابی سے اپ ڈیٹ ہو گئیں",
    Settings: "ترتیبات",
    ShowPassingResults: "پاس کرنے کے نتائج ظاہر کریں",
  },
  UsefulLinks: {
    Title: "مفید لنکس",
    GroupName: "گروپ کا نام:",
    Added: "شامل کیا گیا",
    NoLinks: "کوئی لنکس نہیں",
  },
  DatePicker: {
    Today: "آج",
    Clear: "صاف کریں",
  },
  Promocode: {
    Expired: "گروپ میں اندراج بند کر دیا گیا ہے۔ اپنے مینیجر سے رابطہ کریں",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "اساتذہ نہیں ملے",
    SelectTeacher: "استاد منتخب کریں",
  },
  Loading: {
    Error: "لوڈنگ میں خرابی، صفحہ دوبارہ تازہ کریں",
  },
  MultipleSelect: {
    SelectAll: "سبھی کو منتخب کریں۔",
  },
  Attendance: {
    Title: "حاضری",
  },
};

export default ur;
